class WisteriaConfigController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'ConfigurationService'

	integrationId: 'wisteria'

	initialize: ->
		@isSellOnCommsionEnabled = @ConfigurationService.isEnabled 'POS.Setting.SellOnCommission.Enabled'

		@actions =
			save: !@isSellOnCommsionEnabled
			disconnect: true

	save: ->
		super(@configuration)
			.then (response) =>
				@configuration = response.data
